import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Siempre creí que era vaga. Después de leer el Tomo 1 entendí que mi cerebro simplemente funcionaba diferente. Eso solo ya valió cada peso.',
  name: 'Valentina',
  age: '34 años',
  role: 'diseñadora freelance',
  initials: 'V'
}, {
  quote: 'La Agenda de Micro-Dosis es lo único que funcionó para mí. No me pide que sea otra persona. Me pide que trabaje con quien soy.',
  name: 'Martina',
  age: '31 años',
  role: 'empleada y mamá de dos',
  initials: 'M'
}, {
  quote: 'El Freno de Emergencia me ayudó a ahorrar más en 2 meses que en los 3 años anteriores. Sonará exagerado pero es literal.',
  name: 'Camila',
  age: '29 años',
  role: 'contadora',
  initials: 'C'
}];
export const TestimonialsSection = () => {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-light" data-id="element-319">
      <div className="max-w-4xl mx-auto" data-id="element-320">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-serif font-bold text-center text-dark mb-8" data-id="element-321">
          Lo que dicen quienes ya lo aplicaron
        </motion.h2>

        <div className="grid sm:grid-cols-3 gap-4" data-id="element-322">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-5 sm:p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col" data-id="element-323">
              <div className="flex gap-0.5 mb-3 text-gold-500" data-id="element-324">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} size={14} fill="currentColor" data-id="element-325" />)}
              </div>
              <p className="text-gray-700 text-sm sm:text-base italic mb-4 flex-1" data-id="element-326">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-327">
                <div className="w-9 h-9 rounded-full bg-gold-100 text-gold-700 flex items-center justify-center font-bold text-base border border-gold-200" data-id="element-328">
                  {t.initials}
                </div>
                <div data-id="element-329">
                  <p className="font-bold text-dark text-sm" data-id="element-330">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-331">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};